import { Star } from 'lucide-react'
import { RevealWrapper } from '../components/RevealWrapper'

const TESTIMONIALS = [
  {
    quote: 'Controlo tuda minha operação com o DroneOps. Desde o agendamento até o financeiro, tudo em um lugar só.',
    name: 'V2 Drones',
    detail: '2 drones e 2 pilotos · Alvorada - MG',
    initial: 'V2',
  },
  {
    quote: 'A calculadora de calda sozinha já vale o plano. Parei de desperdiçar produto. Fora isso, o controle financeiro me deu uma visão que eu nunca tinha tido antes.',
    name: 'GV Drones',
    detail: '3 drones e 4 pilotos · Divino - MG',
    initial: 'GV',
  },
]

export function TestimonialsSection() {
  return (
    <section
      aria-labelledby="testimonials-heading"
      style={{
        background: '#0B1D11',
        padding: '72px 24px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden
        style={{
          position: 'absolute',
          bottom: 0, right: 0,
          width: 300, height: 300,
          background: 'radial-gradient(circle, rgba(82,201,126,0.07) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <div style={{ maxWidth: 480, margin: '0 auto', position: 'relative', zIndex: 2 }}>
        <RevealWrapper>
          <span
            style={{
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: 999,
              background: 'rgba(82,201,126,0.1)',
              color: '#52C97E',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              marginBottom: 16,
            }}
          >
            Quem já usa
          </span>

          <h2
            id="testimonials-heading"
            style={{
              fontFamily: 'var(--font-bricolage)',
              fontSize: 'clamp(24px, 7vw, 30px)',
              fontWeight: 800,
              color: '#fff',
              lineHeight: 1.18,
              letterSpacing: '-0.025em',
              marginBottom: 36,
            }}
          >
            Operadores que voam mais
            <br />e se preocupam menos.
          </h2>
        </RevealWrapper>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {TESTIMONIALS.map((t, i) => (
            <RevealWrapper key={i} delay={i * 0.1}>
              <article
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.07)',
                  borderRadius: 24,
                  padding: '22px 22px',
                }}
              >
                <div style={{ display: 'flex', gap: 2, marginBottom: 14 }}>
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star key={idx} size={13} color="#F59E0B" fill="#F59E0B" />
                  ))}
                </div>

                <p
                  style={{
                    fontSize: 15,
                    color: 'rgba(255,255,255,0.78)',
                    lineHeight: 1.65,
                    marginBottom: 18,
                    fontWeight: 500,
                  }}
                >
                  &ldquo;{t.quote}&rdquo;
                </p>

                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div
                    style={{
                      width: 38, height: 38,
                      borderRadius: '50%',
                      background: '#1A5C2E',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontFamily: 'var(--font-bricolage)',
                      fontWeight: 800,
                      color: '#52C97E',
                      fontSize: 14,
                      flexShrink: 0,
                    }}
                    aria-hidden
                  >
                    {t.initial}
                  </div>
                  <div>
                    <p style={{ fontSize: 13, fontWeight: 600, color: '#fff', margin: 0 }}>
                      {t.name}
                    </p>
                    <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', margin: '2px 0 0' }}>
                      {t.detail}
                    </p>
                  </div>
                </div>
              </article>
            </RevealWrapper>
          ))}
        </div>
      </div>
    </section>
  )
}
